<main class="buttons-section">
  <section class="left-section">
    @if(linkText && linkPath){
    <sl-link [text]="linkText" [link]="linkPath" [fullWidth]="true"></sl-link>
    } @else if(tertiaryButton){
    <sl-button
      [variant]="tertiaryButton.variant"
      [color]="tertiaryButton.color"
      [label]="tertiaryButton.text"
      [iconName]="tertiaryButton.icon"
      type="icon-left"
      (clickEvent)="onClickTertiaryButton()"
      id="tertiary"
    >
    </sl-button>
    }
  </section>
  <section class="right-section">
    @if (secondaryButton){
    <sl-button
      [variant]="secondaryButton.variant"
      [label]="secondaryButton.text"
      [color]="secondaryButton.color"
      (clickEvent)="onClickSecondaryButton()"
      id="secondary"
    >
    </sl-button>
    }
    <sl-button
      [variant]="primaryButton.variant"
      [label]="primaryButton.text"
      [color]="primaryButton.color"
      (clickEvent)="onClickPrimaryButton()"
      id="primary"
      [formId]="formId"
      [submit]="!!formId"
    >
    </sl-button>
  </section>
</main>
